import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, DollarSign, Users } from 'lucide-react';
import { useIsMobile } from '../lib/useIsMobile';
export function StatsSection() {
  const isMobile = useIsMobile();
  const stats = [{
    number: 'Millions',
    label: 'Views Generated',
    icon: TrendingUp,
    color: 'from-pink-400 to-rose-400',
    shadow: 'rgba(244,114,182,0.4)'
  }, {
    number: 'Six Figure',
    label: 'Brand Spend',
    icon: DollarSign,
    color: 'from-green-400 to-emerald-400',
    shadow: 'rgba(110,231,183,0.4)'
  }, {
    number: 'Long-Term',
    label: 'Collaborations',
    icon: Users,
    color: 'from-blue-400 to-cyan-400',
    shadow: 'rgba(96,165,250,0.4)'
  }];
  const bounceTransition = {
    type: 'spring',
    stiffness: 260,
    damping: 20
  };
  return <section className="relative z-10 py-24 md:py-32 px-4 md:px-8 max-w-7xl mx-auto" data-id="element-172">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-173">
        {stats.map((stat, index) => <motion.div key={index} initial={{
        y: 50,
        opacity: 0,
        rotate: -5
      }} whileInView={{
        y: 0,
        opacity: 1,
        rotate: 0
      }} viewport={{
        once: true
      }} transition={{
        ...bounceTransition,
        delay: index * 0.1
      }} className="group relative" data-id="element-174">
            <div className="relative p-8 md:p-10 rounded-3xl bg-white border-4 border-gray-800 transition-all duration-300 hover:translate-x-[-4px] hover:translate-y-[-4px]" style={{
          boxShadow: `12px 12px 0px ${stat.shadow}`
        }} onMouseEnter={e => {
          e.currentTarget.style.boxShadow = `16px 16px 0px ${stat.shadow}`;
        }} onMouseLeave={e => {
          e.currentTarget.style.boxShadow = `12px 12px 0px ${stat.shadow}`;
        }} data-id="element-175">
              {/* Icon */}
              <div className={`mb-6 inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-gradient-to-br ${stat.color} border-3 border-gray-800 text-white group-hover:scale-110 group-hover:rotate-12 transition-all duration-300`} data-id="element-176">
                <stat.icon className="w-7 h-7" data-id="element-177" />
              </div>

              {/* Number */}
              <h3 className="font-fredoka font-bold text-5xl md:text-6xl text-gray-800 mb-3 group-hover:scale-105 transition-transform" data-id="element-178">
                {stat.number}
              </h3>

              {/* Label */}
              <p className="text-gray-600 font-bold text-sm md:text-base tracking-wide uppercase" data-id="element-179">
                {stat.label}
              </p>

              {/* Decorative line */}
              <div className={`mt-6 h-2 w-20 bg-gradient-to-r ${stat.color} rounded-full border-2 border-gray-800`} data-id="element-180" />
            </div>
          </motion.div>)}
      </div>
    </section>;
}